/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { AuthorizationRoutes, federation } from '@/constant/api';
import { NameSpace } from '@/constant/store';

import { AutorizationRequestType, AutorizationResponseType } from '@/types/authorization';

export const authorization = createApi({
	reducerPath: NameSpace.authorization,
	baseQuery: fetchBaseQuery({
		baseUrl: federation,
		prepareHeaders: (headers) => {
			const url = window.location.origin;

			headers.set('X-Phs-From-User-Url', url);

			return headers;
		},
	}),
	endpoints: (builder) => ({
		login: builder.mutation<AutorizationResponseType, AutorizationRequestType>({
			query: (body) => ({
				url: AuthorizationRoutes.Session,
				method: 'POST',
				body: { ...body, service: 'phs.booking' },
			}),
		}),
		logout: builder.mutation<null, string>({
			query: (accessToken) => ({
				url: AuthorizationRoutes.Session,
				method: 'DELETE',
				headers: {
					'X-Auth-Token': `Bearer ${accessToken}`,
				},
			}),
		}),
		authorizeSso: builder.mutation<AutorizationResponseType, string>({
			query: (keycloakAccessToken) => ({
				url: `${AuthorizationRoutes.Session}/authorize`,
				method: 'GET',
				headers: {
					Authorization: `Bearer ${keycloakAccessToken}`,
				},
			}),
		}),
	}),
});

export const { useLoginMutation, useLogoutMutation, useAuthorizeSsoMutation } = authorization;
